export default "__VITE_ASSET__l2cSs1YU__"